export const HeaderTabelUserAccess = [
  'Company ID',
  'Username',
  'Roles',
  'Email',
  'Action',
];
